<template>
  <div class="flex justify-between p-4 mb-4 rounded-xl product-info">
    <div class="flex flex-col justify-between">
      <div>
        <div v-for="(fee, index) in summary.fees" :key="`month-fee-${index}`">
          <h2 class="poppins text-lg text-white font-medium">
            {{ fee.name }}
            <span v-if="isEsim">{{ $t('place_order.esim') }}</span>
            <span v-else>{{ $t('place_order.sim_card') }}</span>
          </h2>
        </div>
        <h3
          v-for="(fee, index) in summary.fees"
          :key="`duration-fee-${index}`"
          class="poppins text-green uppercase font-medium"
        >
          <div v-if="isFriendPlan && invitedMonths > 0">
            {{ fee.duration_days !== null && fee.duration_days !== 0 ? fee.duration_days : fee.duration }}
            <span v-if="fee.duration_days !== null && fee.duration_days !== 0">{{
              $t('place_order.order_duration_friend_plan_days')
            }}</span>
            <span v-else-if="1 == fee.duration">{{ $t('place_order.order_duration_friend_plan_1') }}</span>
            <span v-else>{{ $t('place_order.order_duration_friend_plan') }}</span>
          </div>
          <div v-else>
            {{ fee.duration_days !== null && fee.duration_days !== 0 ? fee.duration_days : fee.duration }}
            <span v-if="fee.duration_days !== null && fee.duration_days !== 0">{{
              $t('place_order.order_duration_friend_plan_days')
            }}</span>
            <span v-else-if="1 == fee.duration">{{ $t('place_order.order_duration_1') }}</span>
            <span v-else>{{ $t('place_order.order_duration') }}</span>
          </div>
        </h3>
      </div>
      <p class="text-xs">{{ $t('place_order.order_taxes') }}</p>
    </div>
    <div class="flex-col">
      <div class="text-lg text-alo-400 font-medium poppins">
        <WebMoneyFormatted :amount="payTodayTotal" />
      </div>
    </div>
    <div class="yellow-pill">
      <svg width="51" height="21" viewBox="0 0 51 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.83839 0C0.200871 3.29889 -0.768176 7.82365 0.656441 12.1328C2.89602 18.907 10.2031 22.583 16.9773 20.3434L41.5088 12.2332C46.9268 10.442 50.363 5.40914 50.3759 0H2.83839Z"
          fill="#DAD024"
        />
      </svg>
    </div>
    <div class="pink-pill">
      <svg width="65" height="31" viewBox="0 0 65 31" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16.6652 31C17.2488 22.8615 24.1134 16.437 32.5 16.437C40.8866 16.437 47.7512 22.8615 48.3348 31L65 31C64.401 13.7783 50.0805 -6.52152e-07 32.5 -1.42062e-06C14.9195 -2.18909e-06 0.599044 13.7783 8.85936e-07 31L16.6652 31Z"
          fill="#E05665"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import WebMoneyFormatted from '@/Web/Components/WebMoneyFormatted.vue'

export default {
  components: {
    WebMoneyFormatted,
  },
  props: {
    summary: {
      type: Object,
      required: true,
    },
    isFriendPlan: {
      type: Boolean,
      required: true,
    },
    isEsim: {
      type: Boolean,
      required: true,
    },
    product: {
      type: Object,
      required: false,
      default: () => {},
    },
    invitedMonths: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  computed: {
    payTodayTotal() {
      return (
        (this.summary.fees ?? []).reduce((acc, fee) => acc + (fee.price ?? 0) * fee.quantity, 0) +
        (this.summary.shippings ?? []).reduce((acc, shipping) => acc + (shipping.price ?? 0) * shipping.quantity, 0) +
        (this.summary.deposits ?? []).reduce((acc, deposit) => acc + (deposit.price ?? 0) * deposit.quantity, 0)
      )
    },
  },
}
</script>
